{"errno":-2,"code":"ENOENT","syscall":"open","path":"/Users/mac/Desktop/Robby/packages/core/services/maps-api-loader/lazy-maps-api-loader.ts"}